import { findNodesToPrefetch } from '@atlaskit/node-data-provider';

import { ConfluenceEditorCardProvider } from '@confluence/smartlinks';

import {
	NODE_DATA_PROVIDERS_MAX_NODES_TO_PREFETCH,
	NODE_DATA_PROVIDERS_MAX_NODES_TO_VISIT,
} from './nodeDataProvidersConstants.ts';
import type { JSONNode } from '@atlaskit/editor-json-transformer';

/**
 * Finds and returns smart card nodes from a given document JSON string that should be prefetched.
 *
 * @param docJsonString - The document in JSON string format.
 */
export function findSmartCardNodes(docJsonString: string): JSONNode[] {
	if (!docJsonString) {
		return [];
	}

	const doc = JSON.parse(docJsonString);

	const cardProvider = new ConfluenceEditorCardProvider('custom');

	return findNodesToPrefetch(
		doc,
		[
			{
				provider: cardProvider,
				maxNodesToPrefetch: NODE_DATA_PROVIDERS_MAX_NODES_TO_PREFETCH.smartCard,
			},
		],
		NODE_DATA_PROVIDERS_MAX_NODES_TO_VISIT,
	)[0].nodes;
}
